import { MDSBadge, MDSBadgeVariant, MDSIconKind } from "@/mds";

type HeadsUpLabsBadgeProps = {
  variant?: MDSBadgeVariant;
};

export const HeadsUpLabsBadge = ({ variant = MDSBadgeVariant.Emphasis }: HeadsUpLabsBadgeProps) => {
  return <MDSBadge icon={MDSIconKind.Flask} label="Beta" variant={variant} />;
};
